/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_POLICY_LIST = gql`
  query GetListOfPolicies($input: GetListOfPoliciesInput) {
    getListOfPolicies(input: $input) {
      data {
        nominee {
          firstName
          lastName
          address {
            addressLine1
            country
            city
          }
          gender
          aadharNo
          email
          dob
          mobileNo
          share
        }
        blockchainTxnURL
        countryToBeInsured
        coverage
        createdAt
        discountedPremium
        minDue
        policyId
        policyNumber
        policyOption
        premium
        purchasedAt
        purchasedBy {
          address {
            addressLine1
            city
            country
          }
          bankDetail {
            vuid
            accHolderName
            bankName
            accountNo
            type
            swiftCode
          }
          bannerImg
          bio
          email
          firstName
          image
          lastName
          nationality
          occupation
          userId
          vuid
          primaryContactNo
        }
        status
        type
      }
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
`;
